import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

const AboutContentThree = () => {
  return (
    <div className="dg__market__data pt--130 pb--140">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="market__title">
              <h2>Pricing for All Business Sizes</h2>
              <p>
              Digital tipping just got easier with the Tipping-Token solution.{" "}
              </p>
            </div>
            <div className="market__tab">
              <Tab.Container defaultActiveKey="month">
                <div className="market__filter">
                  <div className="market__select">
                    <select>
                      <option>Free</option>
                      <option>Custom</option>
                    </select>
                  </div>
                  <Nav
                    variant="pills"
                    className="market__nav justify-content-center"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="day">6 Months</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="month">1 year</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="year">2 years</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <Tab.Content>
                  <Tab.Pane eventKey="day">
                    <div className="image-wrapper text-center">
                      <img
                        src={process.env.PUBLIC_URL + "/images/about/cart1.png"}
                        className="img-fluid"
                        alt="chart images"
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="month">
                    <div className="image-wrapper text-center">
                      <img
                        src={process.env.PUBLIC_URL + "/images/about/cart1.png"}
                        className="img-fluid"
                        alt="chart images"
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="year">
                    <div className="image-wrapper text-center">
                      <img
                        src={process.env.PUBLIC_URL + "/images/about/cart1.png"}
                        className="img-fluid"
                        alt="chart images"
                      />
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContentThree;
